"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_boost_1 = require("apollo-boost");
var apollo_client_1 = require("apollo-client");
var apollo_link_context_1 = require("apollo-link-context");
var apollo_link_http_1 = require("apollo-link-http");
var apollo_link_sentry_1 = require("apollo-link-sentry");
var Authentication_1 = require("src/Authentication");
var Env_1 = require("src/Env");
var httpLink = apollo_link_http_1.createHttpLink({
    uri: Env_1.GRAPHQL_URL
});
var sentryLink = new apollo_link_sentry_1.SentryLink();
var authorizedLink = apollo_link_context_1.setContext(function (_, _a) {
    var headers = _a.headers;
    var token = Authentication_1.AuthToken.getToken();
    var additionalHeaders = { 'X-Guest-UUID': Authentication_1.AuthToken.getGuestUUID() };
    if (token) {
        additionalHeaders = Object.assign({}, additionalHeaders, { authorization: "Bearer " + token });
    }
    return { headers: Object.assign({}, headers, additionalHeaders) };
});
var apolloClient = new apollo_client_1.ApolloClient({
    link: authorizedLink.concat(sentryLink).concat(httpLink),
    cache: new apollo_boost_1.InMemoryCache()
});
exports.default = apolloClient;
